import type { U3204DisplayMessage } from '../U3204Service';
import { u3204ResolveExportFile } from './u3204ResolveExportFile';

const U3204_EXPORT_GENERATION_TOOLS = new Set([
  'generate_word_document',
  'generate_excel_report',
  'generate_pdf_report',
]);

/** Message assistant qui a lancé un export Word/Excel/PDF (avant la carte téléchargement). */
export function u3204HasExportGenerationTool(message: Pick<U3204DisplayMessage, 'toolActivity'>): boolean {
  return (message.toolActivity ?? []).some((item) => U3204_EXPORT_GENERATION_TOOLS.has(item.toolName));
}

export type U3204ExportTokenDisplay = {
  /** Messages assistant « pont » : ne pas afficher out sous leur bulle */
  hideOutputOnMessageIds: Set<string>;
  /** Tokens out à afficher sous le message carte export */
  outputTokensByExportMessageId: Map<string, number>;
};

/**
 * Déplace les outputTokens du message tools+narratif vers le message carte Word/Excel/PDF suivant
 * (même tour, avant le prochain user).
 */
export function u3204BuildExportTokenDisplay(
  messages: U3204DisplayMessage[],
  outputTokensByAssistantMessageId: Map<string, number>,
): U3204ExportTokenDisplay {
  const hideOutputOnMessageIds = new Set<string>();
  const outputTokensByExportMessageId = new Map<string, number>();

  for (let index = 0; index < messages.length; index += 1) {
    const message = messages[index];
    if (message.role !== 'assistant' || !u3204HasExportGenerationTool(message)) {
      continue;
    }

    const sourceTokens = outputTokensByAssistantMessageId.get(message.id);
    if (sourceTokens == null) {
      continue;
    }

    for (let lookAhead = index + 1; lookAhead < messages.length; lookAhead += 1) {
      const candidate = messages[lookAhead];
      if (candidate.role === 'user') {
        break;
      }
      if (!u3204ResolveExportFile(candidate)) {
        continue;
      }

      hideOutputOnMessageIds.add(message.id);
      const existingOnExport = outputTokensByExportMessageId.get(candidate.id);
      outputTokensByExportMessageId.set(
        candidate.id,
        existingOnExport != null ? existingOnExport : sourceTokens,
      );
      break;
    }
  }

  return { hideOutputOnMessageIds, outputTokensByExportMessageId };
}
